import { render, staticRenderFns } from "./VDesigningCanvasPointer.vue?vue&type=template&id=66592932&"
import script from "./VDesigningCanvasPointer.vue?vue&type=script&lang=ts&"
export * from "./VDesigningCanvasPointer.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningCanvasPointer.vue?vue&type=style&index=0&id=66592932&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports